import { useLang } from "@/context";
import { Chapter, Reveal } from "@/components/Reveal";

export default function Experience() {
  const { t } = useLang();

  return (
    <section id="experience" data-testid="experience-section" className="py-28 sm:py-36 bg-cream/60">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <Chapter number={t.experience.chapter} label={t.experience.label} />
        <Reveal>
          <h2
            data-testid="experience-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl text-charcoal font-medium max-w-3xl leading-[1.1] mb-16 sm:mb-24"
          >
            {t.experience.title}
          </h2>
        </Reveal>

        <div className="space-y-0">
          {t.experience.items.map((item, i) => (
            <Reveal key={item.years} delay={i * 0.08}>
              <div
                data-testid={`experience-item-${i}`}
                className="group grid grid-cols-12 gap-6 border-t border-taupe/25 py-10 sm:py-14"
              >
                <div className="col-span-12 md:col-span-4">
                  <span className="font-serif text-3xl sm:text-4xl lg:text-5xl text-charcoal/85 font-light tracking-tight group-hover:text-gold transition-colors duration-500">
                    {item.years}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-8">
                  <h3 className="font-serif text-2xl sm:text-3xl text-charcoal font-medium leading-snug">
                    {item.role}
                  </h3>
                  <p className="mt-2 text-[11px] uppercase tracking-[0.26em] text-gold">{item.place}</p>
                  <p className="mt-4 max-w-xl text-sm sm:text-base text-ink/70 leading-relaxed font-light">
                    {item.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-taupe/25" />
        </div>

        <Reveal delay={0.2}>
          <p data-testid="experience-note" className="mt-8 text-xs uppercase tracking-[0.24em] text-taupe">
            {t.experience.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
